
/**
 * Email validation utilities
 */

/**
 * Validates an email format using a simple regex
 */
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Validates required form fields for email submission
 * Returns an object with validation result and optional error message
 */
export const validateEmailForm = (
  name: string, 
  email: string
): { isValid: boolean; errorTitle?: string; errorMessage?: string } => {
  if (!name.trim()) {
    return {
      isValid: false,
      errorTitle: "Campo requerido",
      errorMessage: "Por favor ingrese su nombre."
    };
  }
  
  if (!email.trim()) {
    return {
      isValid: false,
      errorTitle: "Campo requerido",
      errorMessage: "Por favor ingrese su correo electrónico."
    };
  }
  
  if (!isValidEmail(email)) {
    return {
      isValid: false,
      errorTitle: "Correo electrónico inválido",
      errorMessage: "Por favor ingrese un correo electrónico válido."
    };
  }
  
  return { isValid: true };
};
